import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import PolButton from "v4/components/ui/PolButton/PolButton";
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import PennylaneError422
    from "v4/features/front/pennylane/components/PennylaneErrorModal/PennylaneError422";
import PennylaneErrorMessage
    from "v4/features/front/pennylane/components/PennylaneErrorModal/PennylaneErrorMessage";
import { openPennylaneLink, PENNYLANE_MODAL_ERROR_STATUSES } from "v4/features/front/pennylane/pennylane.utils";
import { usePolTranslation } from "v4/hooks/usePolTranslation";
import './PennylaneErrorModal.scss';

export default function PennylaneErrorModal({ status, errorData, invoiceUrl, isLoading, onClose, onRetry }) {
    const { t } = usePolTranslation();

    if (!PENNYLANE_MODAL_ERROR_STATUSES.includes(status)) return null;

    const title = errorData?.title ?? t('pennylane_error_generic');
    const resolvedInvoiceUrl = errorData?.data?.invoice?.url ?? invoiceUrl ?? null;

    return (
        <PolPopup isOpen
                  title={title}
                  titleNoTranslation
                  closePopup={onClose}
                  classNames={{ popup: 'pennylane-error-modal' }}
                  buttonsRender={() => (
                      <>
                          <PolButton onClick={onClose}>
                              {t('close')}
                          </PolButton>
                          {status === 409 && resolvedInvoiceUrl && (
                              <PolButton className="btn-primary btn-full" onClick={() => openPennylaneLink(resolvedInvoiceUrl)}>
                                  {t('pennylane_access_invoice')} <PolIcon icon="external-link"/>
                              </PolButton>
                          )}
                          {status === 502 && (
                              <PolButton className="btn-primary btn-full" onClick={onRetry} isDisabled={isLoading}>
                                  {t('pennylane_error_retry')}
                                  {isLoading && <PolIcon icon="circle-notch" className="spinner"/>}
                              </PolButton>
                          )}
                      </>
                  )}>
            {status === 422
                ? <PennylaneError422 errorData={errorData}/>
                : <PennylaneErrorMessage errorData={errorData}/>}
        </PolPopup>
    );
}
